import { render, staticRenderFns } from "./VAction.vue?vue&type=template&id=2c8f4e84&"
import script from "./VAction.vue?vue&type=script&lang=js&"
export * from "./VAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports